import { WrapperWidget } from '@agentselly/ui';
import { useTranslate } from '@tolgee/react';
import { formatPhoneNumber } from '~/shared/formatPhoneNumber';

interface ContactDetail {
  readonly firstname: string;
  readonly lastname: string;
  readonly phone: string;
  readonly mobile: string;
  readonly email: string;
  readonly portraitImageUrl?: string;
}

interface Props {
  readonly title?: string;
  readonly internalAgent: ContactDetail;
  readonly externalAgent: ContactDetail;
}

export function CockpitInternalExternalAgentWidget(props: Props) {
  const { t } = useTranslate();

  const renderContact = (contact: ContactDetail, jobTitle: string) => (
    <div className="flex flex-col gap-2">
      {Boolean(contact.portraitImageUrl || (contact as any).photoUrl) && (
        <img
          src={
            (contact.portraitImageUrl || (contact as any).photoUrl) as string
          }
          alt={`${contact.firstname} ${contact.lastname}`}
          className="rounded-full flex-none w-[80px] h-[80px] object-cover"
        />
      )}
      <div className="flex flex-col">
        <span className="font-bold">{jobTitle}</span>
        <span>{`${contact.firstname} ${contact.lastname}`}</span>
        <a href={`mailto:${contact.email}`}>
          <span className="text-primary-500 hover:underline">
            {contact.email}
          </span>
        </a>
        <a href={`tel:${contact.phone}`}>
          <span className="text-primary-500 hover:underline">
            {formatPhoneNumber(contact.phone)}
          </span>
        </a>
        {contact?.mobile && (
          <a href={`tel:${contact.mobile}`}>
            <span className="text-primary-500 hover:underline">
              {formatPhoneNumber(contact.mobile)}
            </span>
          </a>
        )}
      </div>
    </div>
  );

  return (
    <WrapperWidget
      title={
        props.title
          ? t(props.title)
          : t('cockpit_internal_external_agents_title')
      }
    >
      <div className="h-full flex flex-col md:flex-row gap-4 pt-8">
        <div className="flex flex-col justify-between w-full md:w-1/2 pr-4 pb-8">
          {renderContact(
            props.internalAgent,
            t('cockpit_internal_agent_job_title'),
          )}
        </div>
        <div className="flex flex-col justify-between w-full md:w-1/2 pr-4">
          {renderContact(
            props.externalAgent,
            t('cockpit_external_agent_job_title'),
          )}
        </div>
      </div>
    </WrapperWidget>
  );
}
